import { Component, Input, OnInit } from '@angular/core';
import { Icon } from './icon.enum';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: false
})
export class IconComponent implements OnInit {
  @Input() icon: Icon;
  numOfShapes: number[];

  // Here must be used the selector from the crm-industrial-font css file
  private iconMapping = {
    account: 1,
    coldlead: 1,
    hotlead: 1,
    appointment: 1,
    call: 1,
    meeting: 1,
    task: 1,
    impact_logo: 14,
    offline: 2,
    sync_unsuccessfully: 4,
    enabled_cart: 2,
    disabled_cart: 2
  };

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    this.numOfShapes = Array(this.iconMapping[this.icon]).fill(0).map((el, i) => i + 1);
  }

}
